import React, { createContext, useCallback } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

export const TablePreferencesContext = createContext();

const defaultPreferences = { currentPage: 1, tablePageSize: 100, dateSortOrder: 'ascend' };

export const TablePreferencesProvider = ({ children }) => {
  const [tablePreferences, setTablePreferences] = useLocalStorage('table-preferences', {});

  const updateTablePreferences = useCallback((key, updates) => {
    setTablePreferences({
      ...tablePreferences,
      [key]: tablePreferences[key]
        ? { ...tablePreferences[key], ...updates }
        : { ...updates }
    })
  }, [tablePreferences])

  const getTablePreferences = useCallback((key, defaults=defaultPreferences) => {
    if (!(key in tablePreferences)) {
      updateTablePreferences(key, defaults);
      return defaults;
    }
    else {
      return tablePreferences[key];
    }
  }, [tablePreferences, updateTablePreferences])

  return <TablePreferencesContext.Provider value={{ getTablePreferences, updateTablePreferences }}>{children}</TablePreferencesContext.Provider>
}
